import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../guards/context";
import { consumer } from "../connectors";

export type Language = "pt-BR" | "en-US" | "es-ES";

export const useLanguage = () => {
  const { i18n } = useTranslation();
  const { user, signin } = useAuth();
  const [language, setLanguage] = useState<Language>(user?.language || 'pt-BR');

  useEffect(() => {
    if (language !== i18n.language && i18n.changeLanguage) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  const updateLanguage = async (lang: Language) => {
    try {
      if (user) {
        const { message } = await consumer('POST', `/preferences/switch-language`, { language: lang });
        signin(message, false)
      }
      setLanguage(lang);
      if (i18n.changeLanguage) {
        i18n.changeLanguage(lang);
      }
    } catch (error) {
      console.error("Error updating language:", error);
    }
  };

  return { language, updateLanguage };
};

